export enum AuraColorType {
  ERROR = 'error',
  WARN = 'warn',
  SUCCESS = 'success',
  INFO = 'info',
  PRIMARY = 'primary',
  NEUTRAL = 'neutral',
}

export interface AuraThemeClasses {
  container: string;
  title: string;
  message: string;
  icon: string;
  button?: string;
}

export class UiThemeUtils {
  private static THEME_MAP: Record<AuraColorType, AuraThemeClasses> = {
    error: {
      container: 'border-red-8 bg-red-3',
      title: 'text-red-a12',
      message: 'text-red-11',
      icon: 'text-red-11',
    },
    success: {
      container: 'border-green-8 bg-green-3',
      title: 'text-green-a12',
      message: 'text-green-11',
      icon: 'text-green-11',
    },
    warn: {
      container: 'border-amber-8 bg-amber-3',
      title: 'text-amber-a12',
      message: 'text-amber-11',
      icon: 'text-amber-11',
    },
    info: {
      container: 'border-blue-8 bg-blue-3',
      title: 'text-blue-a12',
      message: 'text-blue-11',
      icon: 'text-blue-11',
    },
    primary: {
      container: 'border-primary-8 bg-primary-3',
      title: 'text-primary-a12',
      message: 'text-primary-11',
      icon: 'text-primary-11',
    },
    neutral: {
      container: 'border-gray-6 bg-gray-2',
      title: 'text-gray-12',
      message: 'text-gray-11',
      icon: 'text-gray-11',
    },
  };

  public static getAuraTheme(type: AuraColorType | undefined): AuraThemeClasses {
    return (type && this.THEME_MAP[type]) ?? this.THEME_MAP.neutral;
  }
}
